// extracted by mini-css-extract-plugin
export default {"menuItem":"item_menuItem__Mz-+H","selected":"item_selected__E69wj"};